import React from 'react';
import { useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import moment from 'moment';

import notificationEventType from '../../../../../../../config/data/notificationTypes';
import styles from './ReservationNotFoundModal.module.css';


function ReservationNotFoundModal(props) {

  const {
    mode,
    show,
    onHide,
    values,
    handleDelete,
  } = props;

  const rentals = useSelector(({ rentals }) => rentals && rentals.rentals);

  const targetName = mode === 'notification' ? 'Notification' : 'Activity';
  const bookingData = (values?.bookingData && values.bookingData[0]);
  
  const getRentalNameById = (rentalId) => {
    return rentals.find(rental => rental.id === rentalId)?.name || 'N/A';
  };

  const handleAction = () => {
    if (values) {
      const { id } = values;
      handleDelete(id);
    };
    onHide();
  };

  const handleClose = () => {
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size='md'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id='contained-modal-title-vcenter'
          className={styles.modalTitle}
        >
          {values?.message}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        { values?.type === notificationEventType.RESERVATION_NOT_FOUND_TO_UPDATE_RESERVATION && (
          <>
            <p>
              A modification was received, but the corresponding reservation could not be found in your Beehaz system. The reservation was added to your calendar.
            </p>
            <p>
              This may happen in the following cases:
            </p>
            <p>
              <div style={{display: "flex"}}>
                <div style={{paddingInline: "20px"}}>-</div><div>The reservation was deleted in Beehaz but not cancelled through the OTA, so it still existed on the OTA’s side.</div>
              </div>
              <div style={{display: "flex"}}>
                <div style={{paddingInline: "20px"}}>-</div><div>The reservation was never imported into Beehaz when the OTA connection was established.</div>
              </div>
            </p>
            <p>
              Please review your reservations in the OTA’s system and confirm that all active bookings also exist in Beehaz.
            </p>
            <p>Reservation details:</p>
            <p style={{display: "flex"}}>
              <div style={{paddingLeft: "20px"}}>
                <div>OTA:</div>
                <div>Rental:</div>
                <div>Arrival date:</div>
              </div>
              <div style={{paddingLeft: "70px"}}>
                <div>{bookingData?.ota}</div>
                <div>{getRentalNameById(bookingData?.rentalId)}</div>
                <div>{moment(bookingData?.arrive).format('DD MMMM YYYY') || "N/A"}</div>
              </div>
            </p>
          </>
        )}
        { values?.type === notificationEventType.RESERVATION_NOT_FOUND_TO_DELETE_RESERVATION && (
          <>
            <p>
              A cancellation was received, but the corresponding reservation could not be found in your Beehaz system.
            </p>
            <p>
              This may happen in the following cases:
            </p>
            <p>
              <div style={{display: "flex"}}>
                <div style={{paddingInline: "20px"}}>-</div><div>The reservation was deleted in Beehaz but not cancelled through the OTA, so it still existed on the OTA’s side.</div>
              </div>
              <div style={{display: "flex"}}>
                <div style={{paddingInline: "20px"}}>-</div><div>The reservation was never imported into Beehaz when the OTA connection was established.</div>
              </div>
            </p>
            <p>
              Please review your reservations in the OTA’s system and confirm that all active bookings also exist in Beehaz.
            </p>
            <p>Reservation details:</p>
            <p style={{display: "flex"}}>
              <div style={{paddingLeft: "20px"}}>
                <div>OTA:</div>
                <div>Rental:</div>
                <div>Arrival date:</div>
              </div>
              <div style={{paddingLeft: "70px"}}>
                <div>{bookingData?.ota}</div>
                <div>{getRentalNameById(bookingData?.rentalId)}</div>
                <div>{moment(bookingData?.arrive).format('DD MMMM YYYY') || "N/A"}</div>
              </div>
            </p>
          </>
        )}
        <div className={styles.modalButtonContainer}>
          <button
            onClick={handleClose}
            className={styles.grayButton}
          >
            Close
          </button>
          { mode === 'notification' &&
            <button
              onClick={handleAction}
              className={styles.redButton}
            >
              Delete Notification
            </button>
          }
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ReservationNotFoundModal;